/***
 *
 *   FORGOT PASSWORD
 *   Start the password reset process.
 *
 **********/

import { Button } from "components/lib";

export function Confirmation({ t }) {
  return (
    <div className="mb-20">
      <h1>{t("auth.signup.confirmation.title")}</h1>

      <div className="text-center mt-10">
        <Button
          url="/dashboard"
          text={t("auth.signup.confirmation.back_link")}
          className="bg-[#605BFF] hover:bg-[#605BFF]/90 rounded-[10px] w-[169px] text-[16px] font-semibold"
        />
      </div>
    </div>
  );
}
